function sizeReset() {
    var width, height, webwidth, webheight, __bili;
    width = document.documentElement.clientWidth; //获取屏幕的宽度  
    height = document.documentElement.clientHeight; //获取屏幕的高度
    // document.documentElement.offsetHeight //
    // document.documentElement.clientHeight

    if (height / width < 9 / 16) {
        webheight = height;
        webwidth = parseInt(height * 16 / 9);
        // if(height>1080){
        //     webheight=height;
        //     webwidth=parseInt(height*16/9);
        // }else{
        //     webheight=1080;
        //     webwidth=1920
        // }
    } else {
        webwidth = width;
        webheight = parseInt(width * 9 / 16);
        // if(width>1920){
        //     webwidth=width;
        //     webheight=parseInt(width*9/16);
        // }else{
        //     webheight=1080;
        //     webwidth=1920
        // }
    }
    var bili1 = webwidth / 1920;
    var bili2 = webheight / 1080;
    if (webwidth < 1000) {
        return ''
    }
    var bili = bili1 < bili2 ? bili1 : bili2; //宽度的比例和高度的比例进行比较，取值最小的  
    var html = document.querySelector('body'); //选择html节点  
    var rem = 16; //手动设置rem与px的比例；  
    html.style.width = width + "px";
    html.style.height = height + 'px' //webheight + "px";
    html.style.margin = "0 auto"
    html.style.fontSize = rem + "px"; //设置html的默认fontsize为12px。(注意，浏览器中最小值为12px，)  
    __bili = bili / rem; //将比例和rem进行联系。  
    document.documentElement.style.setProperty('--bili', __bili + "rem"); //设置css中的变量为--bili，值为__bili
}


export default {
    sizeReset
}